// Shared constants & typedefs for the platform (DB-agnostic frontend mirror).

export const PLANS = ["starter", "professional", "business", "enterprise"];

export const FEATURES = {
  BOOKINGS: "module.bookings",
  CRM: "module.crm",
  WORKORDERS: "module.workorders",
  INVENTORY: "module.inventory",
  WEBSHOP: "module.webshop",
  INVOICING: "module.invoicing",
  REPORTS: "module.reports",
  AI: "module.ai",
  WL_BRANDING: "whitelabel.branding",
  WL_DOMAIN: "whitelabel.custom_domain",
};

export const ALL_FEATURES = Object.values(FEATURES);

export const BOOKING_STATUSES = [
  "Draft", "Pending", "Confirmed", "In Progress", "Waiting for Parts", "Completed", "Cancelled",
];
export const BOOKING_PRIORITIES = ["Low", "Normal", "High", "Urgent"];
export const BOOKING_TYPES = ["Repair", "On-site", "Remote Support", "Consultation", "Delivery", "Other"];

export const PLAN_FEATURES = {
  // V1: all plans unlock every module (plans differ only by user count + price).
  starter: [...ALL_FEATURES],
  professional: [...ALL_FEATURES],
  business: [...ALL_FEATURES],
  enterprise: [...ALL_FEATURES],
};
